/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_GET_PUBLIC, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(false);
    const [file, set_file] = useState(null);
    const [element, set_element] = useState(null);
    const [pagination_active, set_pagination_active] = useState(1);
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [maintenance, set_maintenance] = useState('');

    const [title, set_title] = useState('');
    const [keywords, set_keywords] = useState('');
    const [description, set_description] = useState('');

    const [background, set_background] = useState('');
    const [logo, set_logo] = useState('');
    const [favicon, set_favicon] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _setting = () => {

		loading(true);

		API_GET_PUBLIC('client/setting__________')
        .then((response) => {
			if(response.data.result === 'success'){
				console.log('setting : ', response.data)
                set_data(response.data.data[0])
                set_maintenance(response.data.data[0].maintenance)

                set_title(response.data.data[0].title)
                set_keywords(response.data.data[0].keyword)
                set_description(response.data.data[0].description)

                set_background(response.data.data[0].background)
                set_favicon(response.data.data[0].favicon)
                set_logo(response.data.data[0].logo)

            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

	}

    // const _read = (pages) => {

	// 	let offsetSync;

    //     if(pages === 1){
            
    //         offsetSync = 0;    
        
    //     }else{

    //         offsetSync = pages ? (20 * pages) - 20 : 0
        
    //     }
        
    //     loading(true);

    //     API_GET_REQUEST('source__________?action=read'
    //         + '&limit=20'
    //         + '&offset=' + offsetSync
    //     , 
	// 	).then((response) => {
    //         if(response.data.result == 'success'){
    //             console.log(JSON.stringify(response.data.data, undefined, 2))
    //             set_data(response.data.data)
	// 		}else if(response.data.error){
	// 			error(response.data.error);
	// 		}
	// 	})
	// 	.catch((e) => {
    //         console.log('catch : ', e)
    //         error(e.message)
    //     }).finally(() => {
    //         loading(false)
    //     })

	// }

    // const _search = () => {
        
    //     if(search.length > 3){
    
    //         API_GET_REQUEST('source__________?action=search'
    //             + '&search=' + search
    //         , 
    //         ).then((response) => {
    //             if(response.data.result == 'success'){
    //                 // console.log(JSON.stringify(response.data.data.list, undefined, 2))
    //                 set_data(response.data.data)
    //                 error('')
    //             }else if(response.data.error){
    //                 error(response.data.error);
    //                 set_data(null)
    //             }
    //         })
    //         .catch((e) => {
    //             console.log('catch : ', e)
    //             error(e.message)
    //         }).finally(() => {
    //             loading(false)
    //         })

    //     }

    // }

    const _uploads = (action) => {

        if(action !== 'text'){
            if(file === null){
                return error('Tidak ada file')
            }
        }

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("action", action);
        data.append("maintenance", maintenance);
        data.append("title", title);
        data.append("keywords", keywords);
        data.append("description", description);

        if(action !== 'text'){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_SERVER + "/api/v1.0/web/settings__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(action !== 'text'){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log('results : ', JSON.stringify(response.data));
                set_file(null)
                set_refresh(random_character(16))
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
                set_file(null)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
            set_file(null)
        })
        .finally(() => {
			loading(false);
            set_file(null)
            document.getElementById("background").value = "";
            document.getElementById("logo").value = "";
            document.getElementById("favicon").value = "";
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        // if(search.length > 0){
        //     _search()
        // }else{
        //     _read()
        // }

        _setting()

    }, [refresh, search])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Web Settings</h1>
                </div>
            </div>
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian pengaturan web</p>
            </div>
            <div className="_font_size_20px _push_b_d _push_t_d">Maintenance</div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_relative">
                        <div onClick={() => {
                            if(element === 'overlay_dropdown'){
                                set_element(null)
                            }else{
                                set_element('overlay_dropdown')
                            }
                        }} className="_btn _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_column _capitalize">
                                    {maintenance}
                                </div>
                                <div className="_push_l_m _push_t_t">
                                    {
                                        element === 'overlay_dropdown' ?
                                            <ion-icon name="chevron-up-outline"></ion-icon>
                                        :
                                            <ion-icon name="chevron-down-outline"></ion-icon>
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            element === 'overlay_dropdown' ?
                                // _left or _right
                                <>
                                    <div className="_fmc_overlay_dropdown _left">
                                        <div onClick={() => set_maintenance('launch')} className="_item">Launch</div>
                                        <div onClick={() => set_maintenance('maintenance')} className="_item">Maintenance</div>
                                    </div>
                                </>
                            : null
                        }
                    </div>
                </div>
                <div>
                    <div onClick={() => {
                        _uploads('text')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Meta Tag</div>
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Title
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_title(e.target.value)}
                        value={title}
                    />
                </div>
            </div>
            
            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Keywords
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        onChange={e => set_keywords(e.target.value)}
                        value={keywords}
                    />
                </div>
            </div>
            <div className="_row">
                <div className="_column">
                    <div className="_relative _push_b_m">
                        <p style={{color: '#888', fontSize: 13}}>
                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                            Description
                        </p>
                        <div className="_e_input">
                            <input 
                                placeholder=""
                                type={'text'} 
                                onChange={e => set_description(e.target.value)}
                                value={description}
                            />
                        </div>
                    </div>
                </div>
                <div style={{marginTop: 32}}>
                    <div onClick={() => {
                        _uploads('text')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Background</div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_bb-input">                  
                        <input
                            id="background"
                            className="custom-file-input" 
                            type="file"
                            name="file"
                            placeholder=""
                            onChange={_files}
                        />
                    </div>
                </div>
                <div>
                    <div onClick={() => {
                        _uploads('background')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>
            <div className="_push_b_d _push_t_d" style={{maxWidth: 600}}>
                {
                    background.length > 0 &&
                    <img src={API_SERVER + '/uploads/' + background} />
                }
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Logo</div>
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_bb-input">                  
                        <input
                            id="logo"
                            className="custom-file-input" 
                            type="file"
                            name="file"
                            placeholder=""
                            onChange={_files}
                        />
                    </div>
                </div>
                <div>
                    <div onClick={() => {
                        _uploads('logo')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>
            <div className="_push_b_d _push_t_d" style={{maxWidth: 200}}>
                {
                    logo.length > 0 &&
                    <img src={API_SERVER + '/uploads/' + logo} />
                }
            </div>

            <div className="_font_size_20px _push_b_d _push_t_d">Favicon</div>
            
            <div className="_row _center_align">
                <div className="_column">
                    <div className="_bb-input">                  
                        <input
                            id="favicon"
                            className="custom-file-input" 
                            type="file"
                            name="file"
                            placeholder=""
                            onChange={_files}
                        />
                    </div>
                </div>
                <div>
                    <div onClick={() => {
                        _uploads('favicon')
                    }} className="_btn _cursor_pointer">
                        Simpan
                    </div>
                </div>
            </div>
            <div className="_push_b_d _push_t_d" style={{maxWidth: 32}}>
                {
                    favicon.length > 0 &&
                    <img src={API_SERVER + '/uploads/' + favicon} />
                }
            </div>

            {/* <div className="_row _center_align">
                <div className="_column">

                </div>
                <div className="_column">
                    
                </div>
            </div> */}

            {/* <div onClick={() => {
                if(element === 'overlay'){
                    set_element(null)
                }else{
                    set_element('overlay')
                }
            }} className="_btn _cursor_pointer">
                fmc overlay btn
            </div>

            {
                element === 'overlay' ?
                    <>
                        <div className="_fmc_overlay">
                            <div className="_fmc_overlay_navbar">
                                <div className="_row _center_align">
                                    <div className="_column">
                                        <p className="_font_size_18px">Overlay</p>
                                    </div>
                                    <div onClick={() => {
                                        if(element === 'overlay'){
                                            set_element(null)
                                        }else{
                                            set_element('overlay')
                                        }
                                    }} className="_push_l_d _btn _cursor_pointer">
                                        Keluar
                                    </div>
                                </div>
                            </div>
                            <div className="_fmc_overlay_content">

                            </div>
                        </div>
                    </>
                : null
            }

            <div className="_relative">
                <div onClick={() => {
                    if(element === 'overlay_dropdown'){
                        set_element(null)
                    }else{
                        set_element('overlay_dropdown')
                    }
                }} className="_btn _cursor_pointer">
                    <div className="_row _center_align">
                        <div className="_column">
                            fmc overlay dropdown btn
                        </div>
                        <div className="_push_l_m _push_t_t">
                            {
                                element === 'overlay_dropdown' ?
                                    <ion-icon name="chevron-up-outline"></ion-icon>
                                :
                                    <ion-icon name="chevron-down-outline"></ion-icon>
                            }
                        </div>
                    </div>
                </div>
                {
                    element === 'overlay_dropdown' ?
                        // _left or _right
                        <>
                            <div className="_fmc_overlay_dropdown _left">
                                <div className="_item">1. oke</div>
                                <div className="_item">1. oke</div>
                                <div className="_item">1. oke</div>
                                <div className="_item">1. oke</div>
                            </div>
                        </>
                    : null
                }
            </div>

            <div className="_relative _push_b_m">
                <p style={{color: '#888', fontSize: 13}}>
                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                    Input
                </p>
                <div className="_e_input">
                    <input 
                        placeholder=""
                        type={'text'} 
                        // onChange={e => set_input(e.target.value)}
                        // value={input}
                    />
                </div>
            </div>

            <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                    
                <input
                    className="custom-file-input" 
                    type="file"
                    name="file"
                    placeholder=""
                    onChange={_files}
                />

            </div>

            <div onClick={() => {

            }} className="_btn _cursor_pointer">
                Simpan
            </div>

            <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari File" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div> */}
            <div style={{height: 100}}></div>
        </>
    );

}

export default Screen;